import React from 'react';
import { BellIcon, AwardIcon, GiftIcon } from 'lucide-react';
import { MobileNotification } from '../ui/MobileNotification';
export const NotificationExamplesSlide = () => {
  const notifications = [{
    title: 'Dagelijkse check-in',
    message: 'Nog één moment voor jezelf – je weekbalans is bijna rond.',
    variant: 'standard'
  }, {
    title: 'Mijlpaal bereikt!',
    message: 'Je hebt nu 5 dagen achter elkaar voor jezelf gezorgd. Dat telt.',
    variant: 'milestone'
  }, {
    title: 'Nieuwe beloning',
    message: 'Je hebt een nieuwe oefening vrijgespeeld: Ademhaling voor focus.',
    variant: 'reward'
  }];
  const textNotifications = ['Je bent dicht bij je weekdoel – één check-in houdt je streak intact.', 'Nog 2 uur om je balansreeks te behouden – pak een rustig moment.', 'Je balansreeks is nu 10 dagen – laten we hem samen verlengen.', 'Je hebt 70% van niveau 2 voltooid – blijf zo doorgaan!', 'Nieuwe badge beschikbaar bij je volgende check-in.', 'Je hebt bijna alle Rustmomenten verzameld deze week.'];
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-559">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-560">
        Gamification in Notificaties
      </h2>
      <div className="flex items-center mb-5" data-id="element-561">
        <BellIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-562" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-563">
          Onze notificaties bevatten subtiele gamification-elementen die
          motiveren zonder opdringerig te zijn, perfect passend bij Mosy's
          premium uitstraling.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" data-id="element-564">
        <div data-id="element-565">
          <h3 className="text-lg font-light text-[#333333] mb-3" data-id="element-566">
            Gamification-elementen in notificaties
          </h3>
          <div className="bg-[#f7f3ef] p-4 rounded-lg mb-4" data-id="element-567">
            <div className="space-y-3" data-id="element-568">
              <div className="flex items-start" data-id="element-569">
                <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-570">
                  <AwardIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-571" />
                </div>
                <div data-id="element-572">
                  <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-573">
                    Streaks & Reeksen
                  </p>
                  <p className="text-xs text-[#666666]" data-id="element-574">
                    Consistente check-ins bouwen "balansreeksen" op, die
                    gebruikers willen behouden
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-575">
                <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-576">
                  <GiftIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-577" />
                </div>
                <div data-id="element-578">
                  <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-579">
                    Beloningen & Ontgrendelingen
                  </p>
                  <p className="text-xs text-[#666666]" data-id="element-580">
                    Nieuwe functies, content en tools worden vrijgespeeld door
                    consistente activiteit
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-581">
                <div className="w-7 h-7 rounded-full bg-white flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" data-id="element-582">
                  <BellIcon className="w-3.5 h-3.5 text-[#d4af37]" data-id="element-583" />
                </div>
                <div data-id="element-584">
                  <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-585">
                    Progressie & Voltooiing
                  </p>
                  <p className="text-xs text-[#666666]" data-id="element-586">
                    Percentages en voortgangsindicatoren geven een gevoel van
                    vooruitgang
                  </p>
                </div>
              </div>
            </div>
          </div>
          <h3 className="text-lg font-light text-[#333333] mb-2" data-id="element-587">
            Voorbeeldteksten met gamification
          </h3>
          <div className="grid grid-cols-1 gap-y-2" data-id="element-588">
            {textNotifications.slice(0, 4).map((notification, index) => <div key={index} className="flex items-start py-2 border-b border-[#f7f3ef]" data-id="element-589">
                <div className="bg-[#f7f3ef] w-6 h-6 rounded-full flex items-center justify-center mr-2 mt-0.5 flex-shrink-0" data-id="element-590">
                  <span className="text-xs text-[#d4af37]" data-id="element-591">{index + 1}</span>
                </div>
                <p className="text-xs text-[#666666] leading-relaxed" data-id="element-592">
                  {notification}
                </p>
              </div>)}
          </div>
        </div>
        <div className="flex flex-col justify-center space-y-4" data-id="element-593">
          <h3 className="text-lg font-light text-[#333333] mb-2 text-center" data-id="element-594">
            Visuele voorbeelden
          </h3>
          {notifications.map((notification, index) => <div key={index} className="flex justify-center transform hover:scale-105 transition-transform" data-id="element-595">
              <MobileNotification title={notification.title} message={notification.message} variant={notification.variant as any} data-id="element-596" />
            </div>)}
        </div>
      </div>
    </div>;
};